import {gridExport} from './all';

const createRisksGrid = function () {
    let $riskRegList = $('#RiskRegList');
    if ($riskRegList.length) {
        let dateTime = new Date(), fileName = 'RiskItemsExport_' + dateTime.getFullYear() + (dateTime.getMonth() + 1) + dateTime.getDate() + '.xlsx', mid = $('#Id').val();

        //Function Declarations
        let onDataBound = function (arg) {
            $('span#numberOfRisks').text(arg.sender._data.length);
        };
        /*End of Function Declarations*/

        //Create Grid
        $riskRegList.kendoGrid({
            columns      : [
                {
                    field: 'rid', hidden: true, menu: false, attributes: {class: ''}
                }, {
                    field: 'rCategory', title: 'Category', attributes: {class: ''}
                }, {
                    field: 'rDesc', title: 'Description', attributes: {class: ''}
                }, {
                    field: 'projCost', title: 'Project Cost Impact', attributes: {class: ''}
                }, {
                    field: 'rPhase', title: 'Project Phase', attributes: {class: ''}
                }, {
                    field: 'respName', title: 'Responsible', attributes: {class: ''}
                }, {
                    field: 'averted', title: 'Averted', attributes: {class: ''}, width: 120
                }
            ], dataSource: {
                autoSync    : true, schema: {
                    model: {
                        id: 'rid', fields: {
                            rid      : {editable: false},
                            rCategory: {editable: false},
                            rPhase   : {editable: false},
                            rDesc    : {editable: false},
                            projCost : {editable: false},
                            respName : {editable: false},
                            averted  : {editable: true, type: 'boolean'}
                        }
                    }
                }, transport: {
                    create         : {
                        url: '/Forms/ProjectReview/UpdateRisks', type: 'POST', dataType: 'json'
                    }, read        : {
                        url: '/Forms/ProjectReview/GetRisks', type: 'GET', dataType: 'json'
                    }, update      : {
                        url: '/Forms/ProjectReview/UpdateRisks', type: 'PUT', dataType: 'application/json; charset=utf-8'
                    }, parameterMap: function (data, type) {
                        let pid = parseInt($('#Project_Pid').val());
                        if (type === 'create') {
                            return {
                                rid: data.rid, averted: data.averted ? 1 : 0
                            };
                        }
                        if (type === 'read') {
                            return {
                                pid: pid, mid: mid
                            };
                        }
                        if (type === 'update') {
                            return {
                                rid: data.rid, averted: data.averted ? 1 : 0
                            };
                        }
                    }
                }
            }, dataBound : onDataBound, toolbar: kendo.template($('#riskTemplate').html()), excel: {
                fileName: fileName, proxyURL: 'https://demos.telerik.com/kendo-ui/service/export', filterable: true
            }, width     : 800, scrollable: true, sortable: {
                mode: 'multiple'
            }, filterable: true, editable: true, columnMenu: true
        });

        //Create addNewBtn
        $('#addNewBtn').kendoButton({
            icon: 'plus'
        });

        //Add Grid Export Functionality
        gridExport();
    }
};

const saveNewRisk = function () {
    let $saveNewRiskBtn = $('#saveRiskItem');

    if ($saveNewRiskBtn.length) {
        $saveNewRiskBtn.click(function () {
            let $rCategory    = $('#prMprExecSumRiskCategory'),
                $rPhase       = $('#prMprExecSumRiskPhase'),
                $rDesc        = $('#prMprExecSumRiskDescription'),
                $projCost     = $('#prMprExecSumRiskCost'),
                $rResponsible = $('#prMprExecSumRiskResponsible'),
                $averted      = $('#riskAverted:checked'),
                risk          = {
                    pid         : parseInt($('#Project_Pid').val()),
                    mid         : $('#Id').val(),
                    rCategory   : $rCategory.val(),
                    rPhase      : $rPhase.val(),
                    rDesc       : $rDesc.val(),
                    projCost    : $projCost.val(),
                    rResponsible: parseInt($rResponsible.val().substring(0, 6)),
                    averted     : $averted.length
                };

            $.post('/Forms/ProjectReview/AddRisk', risk, function () {
                $rCategory.data('kendoDropDownList').select(0);
                $rPhase.data('kendoDropDownList').select(0);
                $rDesc.val('');
                $projCost.data('kendoNumericTextBox').value('');
                $rResponsible.val('');
                $averted.prop('checked', false);
                $('#RiskRegList').data().kendoGrid.dataSource.read();
            });
        });
    }
};

export default function () {
    createRisksGrid();
    saveNewRisk();
}